import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import { USER_TYPE } from "../../../constants/common";
import useUserType from "../../../hooks/useUserType";
import { useNavigateWithLang } from "../../../utils/navigation";
import CustomModal from "../../CustomModal";

const PuzzleGameStartModal = forwardRef(({ onSubmit }, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigateWithLang();
  const { isStudent } = useUserType();
  const { t } = useTranslation();

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleConfirm = () => {
    onSubmit();
    setIsOpen(false);
  };

  const goBack = () => {
    navigate(`/${USER_TYPE.STUDENT.ROLE}/learning-area`);
    setIsOpen(false);
  };
  return (
    <CustomModal
      isOpen={isOpen}
      withCloseButton={false}
      onClose={() => setIsOpen(false)}
      className="max-w-[45rem] rounded-2xl border-8 border-blue-500 bg-[#F1F1F1] shadow-xl"
      contentClassname="px-2 py-6 md:px-10"
    >
      <h2 className="mb-6 text-center text-3xl font-bold text-blue-900">{t("puzzle_game_title")} 🎇</h2>

      <ul className="list-inside list-disc space-y-4 text-lg text-blue-900">
        <li>
          <span className="font-bold"></span>
          {t("puzzle_game.description")}
        </li>
      </ul>

      <div className="mt-10 flex items-center justify-between gap-14">
        {isStudent && (
          <button
            onClick={goBack}
            className="wavy-btn relative w-1/2 rounded-3xl border-4 border-[#ffe4af] bg-orange-500 p-4 text-lg font-semibold text-white transition duration-200"
          >
            {t("back")}
          </button>
        )}
        <button
          onClick={handleConfirm}
          className={`wavy-btn relative ${isStudent ? "w-1/2" : "w-full"} rounded-3xl border-4 border-[#ffe4af] bg-orange-500 p-4 text-lg font-semibold text-white transition duration-200`}
        >
          {t("start")}
        </button>
      </div>
    </CustomModal>
  );
});

export default PuzzleGameStartModal;
